import { Action } from '@ngrx/store';
import { IAddress } from '../models/address.model';

export const SET_ADDRESS = '[Address] Set Address';
export const UNSET_ADDRESS = '[Address] Unset Address';


export class SetAddressActions implements Action {
    readonly type = SET_ADDRESS;

    constructor(public address: IAddress) { }
}

export class UnsetAddresstAction implements Action {
    readonly type = UNSET_ADDRESS;
}

export type acciones = SetAddressActions | UnsetAddresstAction;